<div id="header" class="light-header">
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <a href="/">
          <app-yopa-logo></app-yopa-logo>
        </a>
        @if (shouldShowCross()) {
          <a href="/" target="_self" class="login-close-link">×</a>
        }
      </div>
    </div>
  </div>
</div>
